module.exports = __webpack_public_path__ + "static/media/market-square.16a6b547.jpg";